import { component$ } from "@builder.io/qwik";

interface ProseProps {
  content: string;
}

export const Prose = component$<ProseProps>(({ content }) => {
  return (
    <div
      class="prose prose-gray mx-auto w-full"
      dangerouslySetInnerHTML={content}
    ></div>
  );
});
